import {Injectable} from '@angular/core';
import {AuthService, CacheService, PageService} from '@gallaghercp/core-frontend';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ClientService implements CanActivate {
    provider: any;

    constructor(
        protected auth: AuthService,
        protected router: Router,
        protected pages: PageService,
        protected cache: CacheService
    ) {
    }

    canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.auth.authResumed) {
            this.auth.resume();
        }
        return this.auth.isResumed.pipe(
            take(1),
            map(() => {
                if (this.auth.isAuthenticated()) {
                    return true;
                }
                this.router.navigate(['/login']);
                return false;
            })
        );
    }

    getConfiguration(key?: string): any {
        this.provider = this.auth.serviceProvider;
        if (key) {
            return this.provider && this.provider.configuration && this.provider.configuration[key]
                ? this.provider.configuration[key]
                : false;
        }
        return this.provider && this.provider.configuration ? this.provider.configuration : false;
    }

    getLogoURL(): string {
        return this.getConfiguration('logo').url
            || 'https://storage.googleapis.com/archipelago-assets/solv-energy/SOLV%20Energy%20Logo%20v2.svg';
    }

    getInvertedLogoURL(): string {
        return this.getConfiguration('logoInverted').url
            || 'https://storage.googleapis.com/archipelago-assets/solv-energy/SOLV%20Energy%20Logo%20Inverted.svg';
    }

    getSiteName(): string {
        return this.getConfiguration('name');
    }

    getLogoInvertedURL(): string {
        return this.getConfiguration().logoInverted || this.getLogoURL();
    }

    getHeroImage(): string {
        // Front-end still showing outdated image,
        // bypass config and return direct link
        // TODO(jack): once I have access to Core envs, will troubleshoot this
        return 'https://storage.googleapis.com/archipelago-assets/solv-energy/Eland%20Solar.jpg';

        // return this.getConfiguration('heroImage').url
        //     || 'https://storage.googleapis.com/archipelago-assets/solv-energy/Eland%20Solar.jpg';
    }

    getHeroImageAlt(): string {
        return this.getConfiguration('heroImage').alt || '';
    }

}
